<template>
  <div>
    <div v-if="viewAllJobs">
      <div class="top-button">
        <button class="create-job-btn" @click="$emit('backToPostJob', 'Post Job')">
          <div class="button-text">
            <!-- <img class="job-create-icon" src="../../assets/images/profile-plus.svg" alt="Create Job icon" /> -->
            <div>Create a Job</div>
          </div>
        </button>
      </div>

      <div v-if="bodyList" class="list-container">
        <div class="filter-section">
          <div class="content">
            <div>
              <h3>Company</h3>
            </div>
            <input v-model="companyName" placeholder="Search Company Name"/>
          </div>
          <div class="filter-button">
            <button @click="filterJobsList(companyName)">Filter</button>
          </div>
        </div>

        <div class="list-table" v-if="bodyList && !loading">
          <ListTable
            :headList="headList"
            :bodyList="currentJobsList"
            :emptyStateTitle="'Jobs'"
            :emptyListDescription="'No Jobs Yet, Start by Creating a Job'"
            v-on:viewHandler="linkToCompanyJobs"
          />
        </div>
      </div>

      <div class="pagination"
        v-if="!loading"
      >
        <Pagination
          v-if="bodyList !== null && bodyList.length > 0"
          v-bind:itemsPerPage="itemsPerPage"
          v-bind:totalJobs="activeListLength"
          v-bind:currentPage="currentPage"
          v-on:paginate="paginate"
        />
      </div>

      <!-- Loader Component Here -->
      <div class="loader" v-if="loading">
        <Loader />
      </div>

    </div>

    <div v-if="viewByACompany">
      <div>
        <CompanyJobsList
          v-on:backToJobs="setJobView({view: 'viewAllJobs', name: 'all'})"
          v-on:backToPostJob="$emit('backToPostJob', 'Post Job')"
          v-on:jobDetail="toJobDetail"
          v-on:editJob="toJobEdit"
          :jobCreatorId="jobCreatorId"
          :companyJobsList="companyJobsList"
        />
      </div>
    </div>

  </div>
</template>

<script>
import CompanyJobsList from '../../components/JobsList/CompanyJobsList.vue';
import ListTable from '../../components/body/ListTable.vue';
import Pagination from '../../components/Pagination.vue';
import Loader from '../../components/body/Loader.vue';
import threeDotsIcon from '../../assets/images/tableDots.png';

export default {
  name: 'AgencyJobsList',
  props: ['jobCreatorId'],
  components: {
    CompanyJobsList,
    ListTable,
    Pagination,
    Loader
  },
  data() {
    return {
      viewAllJobs: true,
      viewByACompany: false,
      companyName: null,
      companyJobsList: null,
      threeDotsIcon,
      headList: [
        {
          text: 'COMPANY',
        },
        {
          text: 'EMAIL',
        },
        {
          text: 'CONTACT PERSON',
        },
        {
          text: 'PHONE NUMBER',
        },
        {
          text: 'TOTAL JOBS',
        },
        {
          text: '',
        },
      ],
      bodyList: null,
      allJobs: null,
      itemsPerPage: 10,
      currentPage: 1,
      loading: true,
    };
  },
  async mounted() {
    await this.getPosts();
  },
  methods: {
    toJobDetail(id) {
      this.$emit('jobDetail', id);
    },
    toJobEdit(id) {
      this.$emit('editJob', id);
    },
    setJobView(option) {
      if(option.view === 'viewAllJobs') {
        this.viewAllJobs = true;
        this.viewByACompany = false;
        // Reset list back to all Jobs
      } else if(option.view === 'viewByACompany') {
        this.viewByACompany = true;
        this.viewAllJobs = false;
        // Filter list using option.name
        this.companyJobsList = this.bodyList
          .find(company => {
            return company.company === option.name;
          }).myJobs;
      }
    },
    filterJobsList(name) {
      this.currentPage = 1;
      if(name === '' || !name ) {
        this.bodyList = this.allJobs;
      } else {
        this.bodyList = this.bodyList.filter((job) => {
          return job.company.toLowerCase() === name.toLowerCase();
        });
      }
    },
    linkToCompanyJobs(id) {
      let company = this.bodyList
      .find(company => {
        return company.viewId === id;
      });
      this.setJobView({view: 'viewByACompany', name: company.company});
    },
    getPosts() {
      this.$store
      .dispatch('getMyPosts')
      .then((res) => {
        if(res.response){
          this.bodyList = [];
          this.allJobs = [];
          let body = {};
          let listOfCompanyNames = [];
          let results = this.$store.state.myPosts;

          // Get list of all company names
          results.forEach((post) => {
            listOfCompanyNames.push(post.companyName);
          });

          // Make it unique
          listOfCompanyNames = [...new Set(listOfCompanyNames)];

          // Build bodylist of each company
          listOfCompanyNames.forEach((companyName) => {
            let count = 0;
            let myJobs = [];
            let inReviewCount = 0;
            let scheduledForInterviewCount = 0;
            let shortlistedCount = 0;
            let declinedCount = 0;
            let hiredCount = 0;

            results.forEach((post) => {
              if(post.companyName === companyName){
                count =count + 1;
                myJobs.push(post);
                body = {
                  email: post.companyContactEmail? post.companyContactEmail: '—',
                  contactPerson: post.companyContactPerson? post.companyContactPerson: '—',
                  phone: post.companyContactNumber? post.companyContactNumber: '—',
                  viewId: post.id
                };
                return count;
              }
            });

            body['company'] = !companyName || companyName === '' ?'—' :companyName;
            body['totalJobs'] = count ? count: '0';
            body['myJobs'] = myJobs;

            // count application status on each company's jobs
            body.myJobs.forEach(job=>{
              job.applications.forEach(application=>{
                switch(application.status){
                  case 'in-review':
                    inReviewCount = inReviewCount + 1;
                    break;
                  case 'scheduled-for-interview':
                    scheduledForInterviewCount = scheduledForInterviewCount + 1;
                    break;
                  case 'declined':
                    declinedCount = declinedCount + 1;
                    break;
                  case 'shortlisted':
                    shortlistedCount = shortlistedCount + 1;
                    break;
                  case 'hired':
                    hiredCount = hiredCount + 1;
                    break;
                  default:
                    null;
                    break;
                }
              });

              job['date'] = job.jobDeadline !== ''
                  ? new Date(job.jobDeadline + 'T00:00:00').toDateString()
                  : '—';
              if(!job.jobDeadline || new Date(job.jobDeadline + 'T00:00:00') > Date.now()) {
                job['status'] = 'Active';
              } else if(new Date(job.jobDeadline + 'T00:00:00') <= Date.now()) {
                job['status'] = 'Expired';
              }
              // Add application status count to each job on company object
              job['inReviewCount'] = inReviewCount? inReviewCount: '0';
              job['scheduledForInterviewCount'] = scheduledForInterviewCount? scheduledForInterviewCount : '0';
              job['declinedCount'] = declinedCount? declinedCount: '0';
              job['shortlistedCount'] = shortlistedCount? shortlistedCount: '0';
              job['hiredCount'] = hiredCount? hiredCount: '0';
              inReviewCount = 0;
              scheduledForInterviewCount = 0;
              shortlistedCount = 0;
              declinedCount = 0;
              hiredCount = 0;
            });

            this.allJobs.push(body);

          });

          this.bodyList = this.allJobs.reverse();
          this.loading = false;

        } else {
          this.loading = false;
          this.bodyList = [];
        }
      })
      .catch((err) => {
        this.loading = false;
        this.$toastr.error(
          err.error.error ? err.error.error
          :err.error ? err.error.errorMessage
          :err.error,
          'Error'
        );
      });
    },
    paginate(pageNumber) {
      this.currentPage = pageNumber;
    }
  },
  computed: {
    indexOfLastJob() {
      return this.currentPage * this.itemsPerPage;
    },
    indexOfFirstJob() {
      return this.indexOfLastJob - this.itemsPerPage;
    },
    currentJobsList() {
      return this.bodyList.slice(this.indexOfFirstJob, this.indexOfLastJob);
    },
    activeListLength() {
      return this.bodyList.length;
    }
  }
};
</script>

<style scoped>
  .top-button {
    display: flex;
    justify-content: right;
  }
  .create-job-btn {
    font-size:1.125rem;
    font-weight:600;
    background:var(--colorPrimary);
    border:none;
    color:var(--white);
    border-radius:5px;
    margin-left:30px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.15));
    float: right;
    width: 188px;
  }
  .button-text {
    display: flex;
    justify-content: space-evenly;
    padding: 12px;
    align-items: center;
  }
  .create-job-btn img{
    width:30px;
  }
  .list-container {
    margin-top: 30px;
    background: var(--white);
    border: 0.5px solid rgba(201, 201, 201, 0.35);
    box-sizing: border-box;
    box-shadow: 0px 14px 24px rgba(9, 44, 76, 0.1);
    border-radius: 10px 10px;
  }
.filter-section {
  display: flex;
  flex-direction: row;
  padding: 30px 16px 30px 30px;
}

.filter-section .content {
  margin-right: 24px;
  width: 25%;
}
  .filter-section .content h3 {
  font-family: "montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 1rem;
  line-height: 1.25rem;
  color: var(--colorSecondary);
  padding-bottom: 16px;
}
.filter-section .content input {
  max-width: 100%;
  width: 100%;
  height: 50px;
  box-shadow: 0px 0px 4px 2px rgba(39, 31, 31, 0.15);
  border-radius: 3px;
  outline: none;
  padding: 10px;
  font-family: 'montserrat';
  font-size: 1rem;
  color: rgba(51, 52, 54, 0.7);
  line-height: 1.25rem;
  /* identical to box height */
  -webkit-appearance: auto;
  color: rgba(51, 52, 54, 0.7);
}
.filter-button {
  position: relative;
}
.filter-button button {
  position: absolute;
  width: 159px;
  height: 40px;
  background: var(--colorPrimary);
  bottom: 0;
  border-radius: 5px;
  color: var(--white);
  outline: none;
}
.pagination {
  margin-top: 30px;
  margin-bottom: 20px;
  display: flex;
  justify-content: right;
  align-items: center;
}

</style>
